import { render } from "./YourAge.vue?vue&type=template&id=599cf1af&scoped=true"
import script from "./YourAge.vue?vue&type=script&lang=js"
export * from "./YourAge.vue?vue&type=script&lang=js"

import "./YourAge.vue?vue&type=style&index=0&id=599cf1af&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599cf1af"]])

export default __exports__